import _styled from"@emotion/styled";import*as React from"react";import urlProvider from"@wp/src/common/utils/urlProvider";import{PublicGPLink}from"@wp/src/components/common/PublicSiteLinks";const StyledGPDisclosuresLink=_styled(PublicGPLink)`
  // Should be uniform throughout the app
  font-size: 14px;
  font-weight: 400;

  // Default link styles make Link almost invisible inside tooltip
  // Adding custom styles for better visibility
  ${props=>props.insideTooltip&&"color: white; text-decoration: underline;"}
`;export const GPDisclosuresLink=props=>React.createElement(StyledGPDisclosuresLink,{href:urlProvider.disclosures,noPadding:props.noPadding,insideTooltip:props.insideTooltip},props.children?props.children:"[disclaimer]");